module.exports = __webpack_public_path__ + "img/bv.e8dfd6f0.svg";